export default __webpack_public_path__ + "static/media/marker-yellow.49f695fc.png";